import { Todo } from "@admin/pages/todo";
import type { RouteObject } from "react-router-dom";

const routes = [
  { index: true, element: <Todo /> },
  { path: "completed", element: <Todo /> },
  // { path: "details", element: <DevicesDetails /> },
  // { path: ":identity/events", element: <EventsList /> },
  // { path: ":identity/events/:id", element: <EventsDetail /> },
] satisfies RouteObject[];

export const todoRoute = {
  path: "/todo_management",
  children: routes,
} satisfies RouteObject;
